/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "flir_boson_driver";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface FfcMode {
}

export enum FfcMode_Enum {
  kManualFfc = 0,
  kAutoFfc = 1,
  kExternalFfc = 2,
  kShutterTestFfc = 3,
  UNRECOGNIZED = -1,
}

export function ffcMode_EnumFromJSON(object: any): FfcMode_Enum {
  switch (object) {
    case 0:
    case "kManualFfc":
      return FfcMode_Enum.kManualFfc;
    case 1:
    case "kAutoFfc":
      return FfcMode_Enum.kAutoFfc;
    case 2:
    case "kExternalFfc":
      return FfcMode_Enum.kExternalFfc;
    case 3:
    case "kShutterTestFfc":
      return FfcMode_Enum.kShutterTestFfc;
    case -1:
    case "UNRECOGNIZED":
    default:
      return FfcMode_Enum.UNRECOGNIZED;
  }
}

export function ffcMode_EnumToJSON(object: FfcMode_Enum): string {
  switch (object) {
    case FfcMode_Enum.kManualFfc:
      return "kManualFfc";
    case FfcMode_Enum.kAutoFfc:
      return "kAutoFfc";
    case FfcMode_Enum.kExternalFfc:
      return "kExternalFfc";
    case FfcMode_Enum.kShutterTestFfc:
      return "kShutterTestFfc";
    case FfcMode_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseFfcMode(): FfcMode {
  return {};
}

export const FfcMode = {
  encode(_: FfcMode, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): FfcMode {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFfcMode();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): FfcMode {
    return {};
  },

  toJSON(_: FfcMode): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<FfcMode>, I>>(base?: I): FfcMode {
    return FfcMode.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FfcMode>, I>>(_: I): FfcMode {
    const message = createBaseFfcMode();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
